import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=15bb1f75"
import script from "./PackageItem.vue?vue&type=script&lang=js"
export * from "./PackageItem.vue?vue&type=script&lang=js"
import style0 from "./PackageItem.vue?vue&type=style&index=0&id=15bb1f75&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports